/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_oauth_complete_auth_success_minecraft = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Authentication successful! Redirecting to Minecraft...`)
};

const zh_hans1_oauth_complete_auth_success_minecraft = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`认证成功！正在跳转回 Minecraft...`)
};

const zh_hant1_oauth_complete_auth_success_minecraft = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`登入成功！正在返回 Minecraft…`)
};

const fr_oauth_complete_auth_success_minecraft = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Authentification réussie ! Redirection vers Minecraft…`)
};

const de_oauth_complete_auth_success_minecraft = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Authentifizierung erfolgreich! Weiterleitung zu Minecraft…`)
};

const ja_oauth_complete_auth_success_minecraft = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`認証に成功しました。Minecraft へリダイレクトします…`)
};

const ko_oauth_complete_auth_success_minecraft = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`로그인 성공! Minecraft로 돌아갑니다…`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "zh-Hans" | "zh-Hant" | "fr" | "de" | "ja" | "ko" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const oauth_complete_auth_success_minecraft = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.oauth_complete_auth_success_minecraft(inputs) 
	}
	const locale = options.locale ?? getLocale()
	trackMessageCall("oauth_complete_auth_success_minecraft", locale)
	if (locale === "en") return en_oauth_complete_auth_success_minecraft(inputs)
	if (locale === "zh-Hans") return zh_hans1_oauth_complete_auth_success_minecraft(inputs)
	if (locale === "zh-Hant") return zh_hant1_oauth_complete_auth_success_minecraft(inputs)
	if (locale === "fr") return fr_oauth_complete_auth_success_minecraft(inputs)
	if (locale === "de") return de_oauth_complete_auth_success_minecraft(inputs)
	if (locale === "ja") return ja_oauth_complete_auth_success_minecraft(inputs)
	return ko_oauth_complete_auth_success_minecraft(inputs)
};